import { useState, useEffect, useCallback } from 'react';
import { buildFullContext, ContextBuildResult } from '../services/contextBuilders';

interface UseContextBuildersReturn {
  context: ContextBuildResult | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

export const useContextBuilders = (): UseContextBuildersReturn => {
  const [context, setContext] = useState<ContextBuildResult | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadContext = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await buildFullContext();
      setContext(result);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadContext();
  }, [loadContext]);

  return { context, isLoading, error, refresh: loadContext };
};
